import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, ArrowRight, ChevronRight, ChevronLeft } from 'lucide-react';
import { publicApi } from '@/services/api';

const SUPPLIER_IMAGE_BASE = 'https://nayaceros.com/images/proveedores/';

const socialLinks = [
  { name: 'Facebook', url: 'https://www.facebook.com/aceroytransformacion', icon: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' },
  { name: 'Instagram', url: 'https://www.instagram.com/nayaceros/?hl=es', icon: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z' },
  { name: 'LinkedIn', url: 'https://www.linkedin.com/in/nayaceros-perfiles-y-maquilas-9a854835a/', icon: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z' },
  { name: 'TikTok', url: 'https://www.tiktok.com/@nayaceros', icon: 'M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z' },
];

const serviciosList = [
  'Corte de Lámina y Placa',
  'Doblez de Lámina y Placa',
  'Rolado de Lámina y Placa',
  'Rolado de Perfiles',
  'Corte con Plasma CNC',
  'Corte con Oxicorte',
  'Doblez de Tubo',
  'Roscado',
  'Corte con Sierra Cinta',
  'Barrenado',
  'Punzonado',
  'Maquila en General',
  'Soldadura',
].sort(() => Math.random() - 0.5).slice(0, 7);

const sucursales = [
  {
    nombre: 'Matriz',
    direccion: 'Carr. Federal Tepic-Guadalajara #5251, Camichín de Jauja, C.P. 63508, Tepic, Nayarit. México.',
    telefono: '311 129 2042 y 311 129 2043',
    email: 'ventas@nayaceros.com'
  },
  {
    nombre: 'Sucursal Independencia',
    direccion: 'Independencia #367, Los Llanitos, C.P. 63170, Tepic, Nayarit. México.',
    telefono: '311 223 2624',
    email: 'ventas@nayaceros.com'
  },
  {
    nombre: 'Sucursal Acaponeta',
    direccion: 'Boulevard Morelos #122-Pte, Col. Centro, Acaponeta, Nayarit.',
    telefono: '325 688 1137',
    email: 'ventas@nayaceros.com'
  },
  {
    nombre: 'Centro de Transformación',
    direccion: 'Carretera Federal-15 Tepic-Guadalajara #1779 Las Lomas, C.P. 63511 Ejido de Pantanal, Municipio de Xalisco.',
    telefono: '311 105 5812',
    email: 'ventas@nayaceros.com'
  }
];

const quickLinks = [
  { path: '/nosotros', label: 'Nosotros' },
  { path: '/productos', label: 'Productos' },
  { path: '/servicios', label: 'Servicios' },
  { path: '/procesos', label: 'Procesos' },
  { path: '/contacto', label: 'Contacto' },
];

const FooterV2 = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [branchIndex, setBranchIndex] = useState(0);

  useEffect(() => {
    loadSuppliers();
  }, []);

  const loadSuppliers = async () => {
    try {
      const response = await publicApi.getSuppliers();
      setSuppliers(response.data);
    } catch (error) {
      console.error('Error loading suppliers:', error);
    }
  };

  const nextBranch = () => setBranchIndex((prev) => (prev + 1) % sucursales.length);
  const prevBranch = () => setBranchIndex((prev) => (prev - 1 + sucursales.length) % sucursales.length);

  return (
    <footer className="bg-v2-darker relative overflow-hidden">
      {/* Decorative Line */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-v2-orange via-v2-yellow to-v2-orange" />

      {/* Suppliers */}
      {suppliers.length > 0 && (
        <div className="border-b border-v2-border py-10" data-testid="suppliers-section-v2">
          <div className="max-w-7xl mx-auto px-8">
            <h3 className="text-center text-v2-text-muted font-bold text-sm uppercase tracking-wider mb-6">
              Nuestros Proveedores
            </h3>
            <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
              {suppliers.map(supplier => (
                <div key={supplier.id} className="opacity-60 hover:opacity-100 transition-opacity duration-300">
                  <img 
                    src={`${SUPPLIER_IMAGE_BASE}${supplier.logo_url}`}
                    alt={supplier.nombre}
                    className="h-10 md:h-14 object-contain"
                    onError={(e) => { e.target.style.display='none'; }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Branch Slider */}
      <div className="border-b border-v2-border py-10" data-testid="branches-slider-v2">
        <div className="max-w-7xl mx-auto px-8">
          <h3 className="text-center text-white font-bold text-lg uppercase tracking-wider mb-6 flex items-center justify-center gap-3">
            <span className="w-8 h-0.5 bg-v2-orange" />
            Sucursales
            <span className="w-8 h-0.5 bg-v2-orange" />
          </h3>
          <div className="relative flex items-center justify-center gap-4">
            <button onClick={prevBranch} className="w-10 h-10 bg-v2-light-gray hover:bg-v2-orange rounded-full flex items-center justify-center text-white transition-colors flex-shrink-0" data-testid="branch-prev-v2">
              <ChevronLeft size={20} />
            </button>
            <div className="flex-1 max-w-lg text-center min-h-[120px] flex flex-col justify-center">
              <h4 className="text-v2-orange font-bold text-lg uppercase">{sucursales[branchIndex].nombre}</h4>
              <p className="text-v2-text-muted text-sm mt-2 flex items-start justify-center gap-2">
                <MapPin size={16} className="text-v2-orange flex-shrink-0 mt-0.5" />
                {sucursales[branchIndex].direccion}
              </p>
              <p className="text-white font-semibold mt-2 flex items-center justify-center gap-2">
                <Phone size={16} className="text-v2-orange" />
                {sucursales[branchIndex].telefono}
              </p>
              <p className="text-v2-text-muted text-sm mt-1 flex items-center justify-center gap-2">
                <Mail size={16} className="text-v2-orange" />
                {sucursales[branchIndex].email}
              </p>
            </div>
            <button onClick={nextBranch} className="w-10 h-10 bg-v2-light-gray hover:bg-v2-orange rounded-full flex items-center justify-center text-white transition-colors flex-shrink-0" data-testid="branch-next-v2">
              <ChevronRight size={20} />
            </button>
          </div>
          <div className="flex justify-center gap-2 mt-4">
            {sucursales.map((_, idx) => (
              <button key={idx} onClick={() => setBranchIndex(idx)} className={`h-1 rounded-full transition-all ${idx === branchIndex ? 'w-8 bg-v2-orange' : 'w-3 bg-v2-border'}`} />
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="relative border-b border-v2-border">
        <div className="max-w-7xl mx-auto px-8 py-16">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-2">
                ¿Tienes un proyecto en mente?
              </h2>
              <p className="text-v2-text-muted text-lg">Contáctanos y recibe una cotización personalizada</p>
            </div>
            <Link 
              to="/contacto" 
              className="group flex items-center gap-3 bg-v2-orange hover:bg-v2-orange-dark text-white font-bold uppercase tracking-wider px-8 py-4 transition-all duration-300"
              style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 10px), calc(100% - 10px) 100%, 0 100%)' }}
            >
              Solicitar Cotización
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="relative max-w-7xl mx-auto px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <img src="https://nayaceros.com/images/logo.png" alt="NAYACEROS" className="h-14 mb-6" />
            <p className="text-v2-text-muted leading-relaxed mb-6">
              Empresa dedicada a la transformación, fabricación y distribución de aceros en todas sus formas desde 2007.
            </p>
            <div className="flex items-center gap-2 text-v2-text-muted mb-5">
              <Clock size={16} className="text-v2-orange" />
              <span className="text-sm">Lun-Vie 8:00-18:00 / Sáb 8:00-13:30</span>
            </div>
            {/* Social Links */}
            <div className="flex items-center gap-3" data-testid="social-links-v2">
              {socialLinks.map(social => (
                <a key={social.name} href={social.url} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-v2-light-gray hover:bg-v2-orange rounded-full flex items-center justify-center transition-colors" aria-label={social.name}>
                  <svg className="w-4 h-4 fill-current text-white" viewBox="0 0 24 24"><path d={social.icon}/></svg>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg uppercase tracking-wider mb-6 flex items-center gap-2">
              <span className="w-8 h-0.5 bg-v2-orange" /> Enlaces
            </h4>
            <nav className="flex flex-col gap-3">
              {quickLinks.map(link => (
                <Link key={link.path} to={link.path} className="text-v2-text-muted hover:text-v2-orange transition-colors">
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Servicios */}
          <div>
            <h4 className="text-white font-bold text-lg uppercase tracking-wider mb-6 flex items-center gap-2">
              <span className="w-8 h-0.5 bg-v2-orange" /> Servicios
            </h4>
            <nav className="flex flex-col gap-2">
              {serviciosList.map(s => (
                <Link key={s} to="/servicios" className="text-v2-text-muted hover:text-v2-orange transition-colors text-sm">{s}</Link>
              ))}
            </nav>
          </div>

          {/* Contact + Matriz */}
          <div>
            <h4 className="text-white font-bold text-lg uppercase tracking-wider mb-6 flex items-center gap-2">
              <span className="w-8 h-0.5 bg-v2-orange" /> Matriz
            </h4>
            <div className="flex flex-col gap-4">
              <p className="flex items-start gap-3 text-v2-text-muted text-sm">
                <MapPin size={16} className="text-v2-orange flex-shrink-0 mt-0.5" />
                Carr. Federal Tepic-Guadalajara #5251, Camichín de Jauja, C.P. 63508, Tepic, Nayarit. México.
              </p>
              <a href="tel:3111292042" className="flex items-center gap-3 text-v2-text-muted hover:text-v2-orange transition-colors">
                <Phone size={16} className="text-v2-orange" /> 311 129 2042
              </a>
              <a href="tel:3111292043" className="flex items-center gap-3 text-v2-text-muted hover:text-v2-orange transition-colors">
                <Phone size={16} className="text-v2-orange" /> 311 129 2043
              </a>
              <a href="mailto:ventas@nayaceros.com" className="flex items-center gap-3 text-v2-text-muted hover:text-v2-orange transition-colors">
                <Mail size={16} className="text-v2-orange" /> ventas@nayaceros.com
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="relative border-t border-v2-border">
        <div className="max-w-7xl mx-auto px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-v2-text-muted text-sm">
              © {new Date().getFullYear()} <span className="text-v2-orange">NAYACEROS</span>. Todos los derechos reservados.
            </p>
            <div className="flex items-center gap-6 text-sm">
              <span className="text-v2-text-muted">Transformación y distribución de aceros desde 2007</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterV2;
